import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import I18n from 'PMT/i18n/I18n';

import {
  Product,
  ProductCategory,
  RestaurantMenu,
  ProductPrices,
  CategoryItem,
} from 'PMT/entities/menu';

import {
  Utils,
  ArrayUtils,
} from 'PMT/utils';

import { Modal } from 'react-bootstrap';
import { TextInputLocalized } from 'PMT/components/form';
import LocalizableSelect from 'PMT/components/form/LocalizableSelect';

import Constants from 'constants/Constants'

/**
 *
 */
export default class EditProductCategoryModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    productCategory: PropTypes.objectOf(ProductCategory),

    parentsToPropose: PropTypes.arrayOf(ProductCategory),

    restaurantMenu: PropTypes.objectOf(RestaurantMenu),

    /**
     * @param ProductCategory
     * @type func
     */
    onUpdate: PropTypes.func,

    /**
     * @param RestaurantMenu
     * @type func
     */
    onCreate: PropTypes.func
  };

  static defaultProps = {
    productCategory: null,
    parentsToPropose: [],
  };

  constructor(props) {
    super(props)

    const parents = !this.isEditMode() ? [
      props.restaurantMenu.getRootCategory()
    ] : []

    this.state = {
      productCategory: _.isNull(props.productCategory) ? new ProductCategory() : props.productCategory.copy(),

     validationErrors: [], // contains the productCategory.getValidationErrors() when click on isValid

      parents,
    }
  }

  get productCategory(): ProductCategory {
    return this.state.productCategory;
  }

  isEditMode(): boolean {
    return !_.isNull(this.props.productCategory);
  }

  isValid(): boolean {
    return !_.isEmpty(this.productCategory.localizedNames);
  }

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  onDelete = (event) => {
    event.preventDefault();

    this.props.onDelete(this.props.productCategory);
  };

  onChange = (productCategory: ProductCategory) => {
    this.setState({
      productCategory
    });
  };

  onNameChange = (newValue: string) => {
    const productCategory:ProductCategory = this.productCategory;
    productCategory.localizedNames = newValue;
    this.onChange(productCategory);
  };

  onDescriptionChange = (newValue: string) => {
    const productCategory:Product = this.productCategory;
    productCategory.description = newValue;
    this.onChange(productCategory);
  };

  onChangeParents = (parentsOptions: SelectOptions)  => {
    console.log(parentsOptions);

    const parents = parentsOptions.map((option: SelectOption) => {
      return option.value;
    });

    this.setState({
      parents
    });
  };

  onValidate = (event) => {
    event.preventDefault();

    const productCategory:ProductCategory = this.productCategory;

    /**
     * We need to create a unique pos id if  we create a new product
     */
    if (!this.isEditMode()) {
      productCategory.id = `cat_${Utils.generateUID()}`;

      /**
       * Activated by default.
       * @type {boolean}
       */
  //    productCategory.activated = true;
    } else {
      productCategory.id = this.props.productCategory.id;
    }

    if (productCategory.isValid()) {
      if (this.isEditMode()) {
        this.props.onUpdate(productCategory);
        this.onClose();
      } else {
        const restaurantMenu: RestaurantMenu = this.props.restaurantMenu;
        restaurantMenu.categories.push(productCategory);

        const newCategoryItem = new CategoryItem();
        newCategoryItem.id = productCategory.id;
        newCategoryItem.type = CategoryItem.Type.CATEGORY;

        _.each(restaurantMenu.categories, (category) => {
          const isParent = ArrayUtils.exists(this.state.parents, (parent) => {
            return parent.id === category.id;
          });

          if (isParent) {
            category.items.unshift(newCategoryItem.copy());
          }
        });

        // send to the api
        this.props.onCreate(restaurantMenu);
        this.onClose();
      }
    } else {
      const validationErrors = productCategory.getValidationErrors();
      console.info('category invalid', validationErrors);
      this.setState({
        validationErrors
      });
    }
  };

  //
  get title(): string {
    if (_.isNull(this.props.productCategory)) {
      return I18n.tr('components.menu.edit_category.new');
    }
    return I18n.tr('components.menu.edit_category.edit');
  }

  // -- renderers

  renderBody() {
    return (
      <form
        className="form form-horizontal product_category_create__form"
        role="form"
        noValidate
      >
        <div className="form-group">
          <div className="required col-xs-4 control-label">
            <label>
              {I18n.tr('components.menu.edit_category.name')}
            </label>
          </div>
          <div className="col-xs-6">
            <TextInputLocalized
              locales={Constants.localesForTranslation}
              values={this.productCategory.localizedNames}
              isRequired
              className="form-control"
              placeholder="Nom"
              onChange={this.onNameChange}
            />
          </div>
          <div className="form_error col-xs-6 col-xs-offset-4">
            {this.state.validationErrors.name}
          </div>
        </div>

        {/* <div className="form-group">
          <div className="col-xs-4 control-label">
          <label>{I18n.tr('components.menu.edit_category.description')}</label>
          </div>
          <div className="col-xs-6">
          <TextInput
          value={this.productCategory.description}
          isRequired
          className="form-control"
          placeholder="Description"
          onChange={this.onDescriptionChange}
          />
          </div>
          <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.description}
          </div>
        </div> */}

        {this.renderParentCategoryChooser()}

        <div className="row">

          <div className="col-xs-6 text-left">
            {/* {this.props.productCategory !== null && // only on edit mode
              <button
              type="submit"
              className="btn btn-danger"
              onClick={this.onDelete}
              >
              {I18n.tr('components.menu.edit_category.delete')}
              </button>
            } */}
          </div>

          <div className="col-xs-6 text-left">
            <button
              type="submit"
              onClick={this.onValidate}
              className="btn btn-primary"
              disabled={!this.isValid()}
            >
              {I18n.tr('components.menu.edit_category.submit')}
            </button>
          </div>

        </div>
      </form>
    );
  }

  renderParentCategoryChooser() {
    if (this.isEditMode()) { // edit not supported yet.
      return (null);
    }

    const selectedParentsValues: SelectOptions = [];
    const options: SelectOptions = this.props.parentsToPropose.map((category) => {
      const label = (category.id === this.props.restaurantMenu.rootCategoryId) ? I18n.tr('menu.category.add_item.main_category') : category.name;
      const option = {
        label,
        value: category,
      }

      const isSelected = ArrayUtils.exists(this.state.parents, (parent) => {
        return parent.id === category.id;
      });

      if (isSelected) {
        selectedParentsValues.push(option);
      }

      return option;
    });

    return (
      <div className="form-group">
        <div className="required col-xs-4 control-label">
          <label>
            {I18n.tr('components.menu.edit_category.parent_category')}
          </label>
        </div>
        <div className="col-xs-6">
          <LocalizableSelect
            name="action"
            value={selectedParentsValues}
            options={options}
            clearable={false}
            onChange={this.onChangeParents}
            multi
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {this.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/restaurantMenu/productCategoryModal/EditProductCategoryModal.js